import styled from "styled-components"
import { BLACK, SKY_BLUE } from "@styles/colors"
import { INTER } from "@styles/fonts"

export const Container = styled.div`
  background: ${SKY_BLUE};
  width: 100%;
`

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 1vh;
  margin-bottom: 3vh;
`

export const AmountText = styled.span`
  font-family: ${INTER.semiBold};
  font-size: 20px;
  color: ${BLACK};
`

export const TransactionTypeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 3vh;
`
